import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';

export default ({ C, value, style, button }) => {
  return (
    <View style={[{ flex: 1, maxWidth: '100%', justifyContent: 'center', alignContent: 'center', alignItems: 'center', marginTop: scale(100) }, style]}>
      <Svg icon="search" color="Label/Light/Tertiary" width={scale(45)} height={scale(45)} />
      <Text style={[font['Title 2'], { color: C('Label/Light/Primary'), textAlign: 'center' }]}>
        {i18n.t('No Results for "{{value}}"', { value })}
      </Text>
      <Text style={[font['Subhead 1'], { color: C('Label/Light/Tertiary'), textAlign: 'center' }]}>
        {i18n.t('Check the spelling or try a new search')}
      </Text>
      {button ? <View style={{ marginTop: scale(20) }}>{button}</View> : null}
    </View>
  );
};
